import { z } from 'zod';

export const UnitStatusTrippedUnitsSchema = z.object({
  frontendId: z.string(),
  since: z.date(),
});

export const UnitStatusSchema = z.object({
  operational: z.number(),
  tripped: z.array(UnitStatusTrippedUnitsSchema),
});

export type UnitStatusTrippedUnits = z.infer<
  typeof UnitStatusTrippedUnitsSchema
>;
export type UnitStatus = z.infer<typeof UnitStatusSchema>;
